import { TextsState } from '../../../../@types';
import activeTexts from './activeTexts';
import { isConnect } from '../../../../utils/isConnect';
import connectTexts from './initialData/InitialState.connect.data';

const initialState: TextsState = {
  default: isConnect() ? connectTexts : activeTexts,
};

export default initialState;
